import { Directive, HostListener, ElementRef } from '@angular/core';


@Directive({
  selector: '[appSelectText]'
})

export class SelectTextDirective {

  element: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.element = elementRef.nativeElement;
  }
  @HostListener('focus') onFocus () {
    this.element.setSelectionRange(0, this.element.value.length);
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/shared/select-text.directive/select-text.directive.ts